import { z } from 'zod';

import { chatContextRegistry } from '#components/chat/chatContextRegistry';
import { InstanceIdType } from '#schema/defs';
import { CogniteDescribableModel } from '#schema/model/cdm/CogniteDescribableModel';
import { CogniteSourceableModel } from '#schema/model/cdm/CogniteSourceableModel';
import { CogniteVisualizableModel } from '#schema/model/cdm/CogniteVisualizableModel';

export const CogniteAssetBaseModel = z.object({
  ...CogniteVisualizableModel.shape,
  ...CogniteDescribableModel.shape,
  ...CogniteSourceableModel.shape,

  parent: InstanceIdType.optional(),
  root: InstanceIdType.optional(),
  path: InstanceIdType.array().optional(),
  pathLastUpdatedTime: z.coerce.date().optional(),
  assetClass: InstanceIdType.optional(),
  type: z.string().optional(),
  files: InstanceIdType.array().optional(),
  equipment: InstanceIdType.array().optional(),
  activities: InstanceIdType.array().optional(),
  timeSeries: InstanceIdType.array().optional(),
});

export const CogniteAssetModel = CogniteAssetBaseModel.extend({
  get parent() {
    return CogniteAssetModel.optional();
  },
  get root() {
    return CogniteAssetModel.optional();
  },
  get path() {
    return CogniteAssetModel.array().optional();
  },
  get children() {
    return CogniteAssetModel.array().optional();
  },
});

export type CogniteAssetModelInput = z.input<typeof CogniteAssetModel>;
export type CogniteAssetModelOutput = z.output<typeof CogniteAssetModel>;

chatContextRegistry.add(CogniteAssetModel, {
  getPrompt: (asset) =>
    `The user is viewing an asset named \`${asset.name}\` with externalId=\`${asset.externalId}\` and space=\`${asset.space}\`. The asset description is "${asset.description}".`,
});
